import {
  config,
  createRequest,
  getOrderDetail,
  OrderAuditStatus,
  OrderStatus,
  type OrderDetail,
} from "@ifa/utils";

const request = createRequest({
  baseURL: config.apiBaseUrl,
});

const ORDER_PAGE_STATUS_STORAGE_KEY = "order-page-status";

export interface OrderPageStatusContext {
  orderStatus?: string;
  orderAuditStatus?: string;
}

export interface OrderDetailPageContext extends OrderPageStatusContext {
  mode: "edit" | "view";
  isCorrectionEdit?: boolean;
}

function getOrderPageStatusStorageKey(orderId: string | number) {
  return `${ORDER_PAGE_STATUS_STORAGE_KEY}:${orderId}`;
}

export function cacheOrderPageStatus(
  orderId: string | number,
  status: OrderPageStatusContext,
) {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.setItem(
    getOrderPageStatusStorageKey(orderId),
    JSON.stringify(status),
  );
}

export function readCachedOrderPageStatus(
  orderId: string | number,
): OrderPageStatusContext {
  if (typeof sessionStorage === "undefined") return {};

  const rawValue = sessionStorage.getItem(getOrderPageStatusStorageKey(orderId));
  if (!rawValue) return {};

  try {
    return JSON.parse(rawValue);
  } catch (error) {
    console.error("Failed to parse cached order page status:", error);
    return {};
  }
}

export function getPendingOrderDetail(orderId: string | number) {
  return request.get<OrderDetail>("/advisor/order/pending-detail", {
    params: { orderId },
  });
}

export function shouldUsePendingDetail(context: OrderDetailPageContext) {
  if (context.isCorrectionEdit) {
    return true;
  }

  return (
    context.orderStatus === OrderStatus.OrderAudit &&
    context.orderAuditStatus === OrderAuditStatus.PendingModification
  );
}

export function getOrderDetailForPage(
  orderId: string | number,
  context: OrderDetailPageContext,
) {
  if (shouldUsePendingDetail(context)) {
    return getPendingOrderDetail(orderId);
  }

  return getOrderDetail(orderId);
}
